import { createContext } from "solid-js";
export const TransitionGroupContext = createContext(null);
export default TransitionGroupContext;
